
import React from "react";
import { CheckCircle } from "lucide-react";

// WhatsApp Leads Data
const whatsappLeadsData = [
  {
    heading: "Promote Your Home Decor with WhatsApp Broadcasts",
    points: [
      "Launch click-to-WhatsApp ads to grab customer interest.",
      "Turn curious visitors into leads with quick follow-ups.",
      "Add a WhatsApp widget to your site for instant chats.",
      "Share WhatsApp links on social media to spark conversations.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/home_decor_furnishings/home_decor_furnishings_2.png",
  },
  {
    heading: "Turn Interest into Sales with Smart Follow-Ups",
    points: [
      "Send tailored decor suggestions based on customer tastes.",
      "Follow up with WhatsApp broadcasts of similar deals.",
      "Run fun contests to keep customers excited.",
      "Highlight your loyalty program and its perks.",
    ],
    // buttonText: "Get Start ",
    buttonText: "Meta Policy for health Home Decor",
    buttonLink:"https://transparency.meta.com/policies/ad-standards/",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/home_decor_furnishings/home_decor_furnishings_3.png",
  },
  {
    heading: "Make Post-Purchase a Breeze with WhatsApp",
    points: [
      "Keep customers updated with automated order alerts.",
      "Send shipping and delivery updates to ease their minds.",
      "Ask for feedback after purchase to improve your offerings.",
      "Encourage reviews from happy customers.",
      "Run surveys to dig deeper into what they love.",
    ],
    buttonText: "Get Start ",
    buttonLink:"https://app.chatmitra.com/signin",
    image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/home_decor_furnishings/home_decor_furnishings_4.png",
  },
];

const Decorcycle = () => {
  return (
    <>
      <div className="bg-gradient-to-r from-pink-200 to-pink-300 py-12 px-4 text-center">
        <h1 className="text-4xl font-bold text-gray-800">How WhatsApp Boosts Your Home Decor Business</h1>
        <div className="my-4 flex justify-center">
          <span className="w-20 h-1 bg-gray-500 rounded-full"></span>
        </div>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">With the home decor market racing toward <span className="font-bold">$805.75 billion</span> by 2026 at a 5% CAGR, WhatsApp helps you reach customers faster and stand out in the crowd!</p>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-20">
        {whatsappLeadsData.map((item, index) => (
          <div key={index} className={`flex flex-col lg:flex-row items-center gap-16 my-20 ${index % 2 === 1 ? "lg:flex-row-reverse" : ""}`}>
            <div className="w-full lg:w-1/2">
              <img src={item.image} alt={item.heading} className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl font-bold text-gray-900 mb-6">{item.heading}</h2>
              <ul className="space-y-4 text-gray-700">
                {item.points.map((point, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              {item.buttonText && (
                <a
                href={item.buttonLink}
                className="mt-6 inline-block bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors"
              >
                {item.buttonText}
              </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Decorcycle;